module.exports = __webpack_public_path__ + "static/media/logo-blue.d9cbccb6.svg";